module.exports = __webpack_public_path__ + "static/vmware_13.2ce24443.jpg";